import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import translations from '@nike/gameday-translations/web';

import { H2 } from '../../../components';
import { TranslatedCopy } from '../../../intl/TranslatedCopy';

export const LanguagePickerCardRegion = ({ onClick, selected, data: { key, region } }) => {
  const onClickHandler = () => {
    if (onClick) onClick(region);
  };

  const { en } = translations;
  const dataE2E = en[region]?.replace(/ /g, '-')?.toLowerCase();

  return (
    <div
      data-e2e={dataE2E}
      className={classnames('flex-container column center pt10-sm pb7-sm prl7-sm m4-sm selectable', {
        'border-medium-grey': selected
      })}
      onClick={onClickHandler}
    >
      <img className={`regionCard region_${key.toLowerCase()} border-light-grey`} alt='' />
      <H2 className='mt3-sm'>
        <TranslatedCopy id={region} />
      </H2>
    </div>
  );
};

LanguagePickerCardRegion.propTypes = {
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    key: PropTypes.string.isRequired,
    region: PropTypes.string.isRequired
  }).isRequired
};

export default LanguagePickerCardRegion;
